export default __webpack_public_path__ + "static/media/windows.5e5b1da2.svg";